import { apiClient } from './apiClient.js'

export const currencyApi = {
    fetchCurrencies: async (config, accessToken) => {
        const url = `${config.accountApiUrl}/currencies`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET",
                headers: {
                    'Clientid': '3'
                }
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        return c.currencies
                    }
                )
            }
        )
    }
}